import { render } from "./instagramIntegration.vue?vue&type=template&id=7b796bac"
import script from "./instagramIntegration.vue?vue&type=script&lang=js"
export * from "./instagramIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__